export enum OriginAppName {
    Essentials = 'Essentials',
    ConsumerPortal = "ConsumerPortal"
}